var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cs from 'classnames';
import { Typography } from 'ui-kit/typography';
import { getLocale } from 'common/helpers/get-locale';
import styles from './formatted-numberd.module.scss';
var LOCALES_MAP = {
    ru: 'ru-RU',
    'ru-RU': 'ru-RU',
    en: 'en-US',
    ar: 'ar',
};
export var FormattedNumber = function (_a) {
    var value = _a.value, locale = _a.locale, prefix = _a.prefix, postfix = _a.postfix, withoutPrefixGap = _a.withoutPrefixGap, withoutPostfixGap = _a.withoutPostfixGap, withRtlSupporting = _a.withRtlSupporting, className = _a.className, rest = __rest(_a, ["value", "locale", "prefix", "postfix", "withoutPrefixGap", "withoutPostfixGap", "withRtlSupporting", "className"]);
    var currentLocale = locale !== null && locale !== void 0 ? locale : getLocale();
    var content = (_jsxs(Typography, __assign({ className: cs(styles.formattedNumber, className), component: "span" }, rest, { children: [prefix && (_jsxs(_Fragment, { children: [prefix, withoutPrefixGap ? null : _jsx(_Fragment, { children: "\u00A0" })] })), Number(value || 0).toLocaleString(LOCALES_MAP[currentLocale] || LOCALES_MAP.en), postfix && (_jsxs(_Fragment, { children: [withoutPostfixGap ? null : _jsx(_Fragment, { children: "\u00A0" }), postfix] }))] })));
    return withRtlSupporting ? _jsx("bdi", __assign({ dir: "auto" }, { children: content })) : content;
};
